import { render } from "./Company.vue?vue&type=template&id=1d1b93f8"
import script from "./Company.vue?vue&type=script&lang=js"
export * from "./Company.vue?vue&type=script&lang=js"

import exportComponent from "/home/olt/CloudRaiseWebSite/vue/client/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__